import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { API_BASE_URL } from './config';
import ScrollToTop from './HOC/ScrollToTop';

/* Commented route/component imports (for reference):
// import { Specific } from './Specific/Specific';
// import { Cart } from './Cart/Cart';
// import { Address } from './Address/Address';
// import { FullReviews } from './FullReview/FullReviews';
// import { Orders } from './Orders/Orders';
// import { MyProfile } from './MyProfile/MyProfile';
// import { MyProfileEdit } from './MyProfile/Edit/MyProfileEdit';
// import { Wishlist } from './Wishlist/Wishlist';
// import { Login } from './Auth/Login/Login';
// import { Register } from './Auth/Register/Register';
// import { Filter } from './Filter/Filter';
// import { Specific } from './Specific/Mobile/Specific';
// import { Wishlist } from './Wishlist/Mob/Wishlist';
// import { Cart } from './Cart/Mob/Cart';
// import { Address } from './Address/Mob/Address';
// import { MyProfileEdit } from './MyProfile/Edit/Mob/MyProfileEdit';
// import { Orders } from './Orders/Mob/Orders';
// import { MyProfile } from './MyProfile/Mob/MyProfile';
// import { Login } from './Auth/Login/Mob/Login';
// import { Register } from './Auth/Register/Mob/Register';
// import { FullReviews } from './FullReview/Mob/FullReviews';
*/

// Use deployed or local backend (set REACT_APP_API_URL in .env for deployed)
axios.defaults.baseURL = API_BASE_URL;

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <App />,
//   },
//   {
//     path: "/products",
//     element: <Products />,
//   },
//   {
//     path: 'slider',
//     element: <Slider />
//   },
//   {
//     path: 'specific',
//     element: <Specific />
//   },
//   {
//     path: 'cart',
//     element: <Cart />
//   },
//   {
//     path: 'address',
//     element: <Address />
//   },
//   {
//     path: 'full-review',
//     element: <FullReviews />
//   },
//   {
//     path: 'orders',
//     element: <Orders />
//   },
//   {
//     path: 'profile',
//     element: <MyProfile />
//   },
//   {
//     path: 'profile/edit',
//     element: <MyProfileEdit />
//   },
//   {
//     path: 'wishlist',
//     element: <Wishlist />
//   },
//   {
//     path: 'auth/login',
//     element: <Login />
//   },
//   {
//     path: 'auth/register',
//     element: <Register />
//   },
//   {
//     path: 'filter',
//     element: <Filter />
//   },
// ]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <Layout>
      <RouterProvider router={router} />
    </Layout> */}

    <BrowserRouter>
      < ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
